import { number } from "ng-brazil/number/validator";

export class ContractAssignor {

    public standardValue: number;
    public standardPeriodId: number;
    public isEditable: boolean;
    public maximumValue: number;
    public incrementValue: number;
    public feeValue: number = 0;
    public isPercentage: boolean = false;
    public inPriority: boolean = false;
    public productEligibility: ProductEligibility;

    public selected: boolean;

    constructor(
        public id: number,
        public SituationId: number,
        public descricaoSituacao: string,
        public createDate: Date,
        public validityStart: Date,
        public validityEnd: Date,
    ) { }
}

export class ProductEligibility {
    public id: number;
    public createDate: Date;
    public updateDate: Date;
    public situationId: number;
    public feeValue: number;
    public isPercentage: boolean;
    public product: Product;
}

export class Product {
    public produtoId: number;
    public produtoGuid: string;
    public idPessoaAdministradora: number;
    public descricaoProduto: string;
    public importante: string;
    public beneficio: boolean;
    public corProduto: string;
    public dataInicio: Date;
    public dataFim: Date;
    public universal: boolean;
    public categoriaProduto: number;
    public iconeProduto: string;
    public taxaProduto: number;
    public ehPorcentagem: boolean;
}

export class UpdateContractAssignor {
    constructor(
        public standardValue: number,
        public standardPeriodId: number,
        public isEditable: boolean,
        public maximumValue: number,
        public incrementValue: number,
        public inPriority: boolean = false
    ) { }
}